import {
  APP_CONFIG_LOADING,
  APP_CONFIG_SUCCESS,
  APP_CONFIG_ERROR,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  themeConfig: null,
  customReportsConfig: [],
  cyclopsConfig: null,
};

const appConfig = (state = initialState, action) => {
  switch (action.type) {
    case APP_CONFIG_LOADING:
      return { ...state, loading: true, error: null };
    case APP_CONFIG_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case APP_CONFIG_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default appConfig;
